import {apiClient} from 'core/apiClient';
import {DocumentUtilisationData} from 'types';

export async function fetchDocumentUtilisationCreate(params: DocumentUtilisationData) {
    if (params.file) return fetchDocumentUtilisationCreateWithFile(params);
    const data = await apiClient.post('/marking/utilisation', params);
    return {data};
}

export async function fetchDocumentUtilisationCreateWithFile(params: DocumentUtilisationData) {
    const payload: Record<string, any> = {
        ...(params.groupMarkingCode && {groupMarkingCode: params.groupMarkingCode}),
        storageLocationId: params.storageLocationId,
        applicationDate: params.applicationDate,
        manufacturingDate: params.manufacturingDate,
        file: params.file,
    };
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => formData.append(key, value));
    const data = await apiClient.post('/marking/utilisation/upload', formData, {
        headers: {'Content-Type': 'multipart/form-data'},
    });
    return {data};
}
